import { render, staticRenderFns } from "./AddSendEmpolyee.vue?vue&type=template&id=b5ffd6e2&"
import script from "./AddSendEmpolyee.vue?vue&type=script&lang=js&"
export * from "./AddSendEmpolyee.vue?vue&type=script&lang=js&"
import style0 from "./AddSendEmpolyee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports